export enum TriggerState {
    New,
    Waiting,
    Queued,
    Running,
    Deactivated,
    Deleted
}
